/*
Copyright 2025 Adobe. All rights reserved.
This file is licensed to you under the Apache License, Version 2.0 (the "License");
you may not use this file except in compliance with the License. You may obtain a copy
of the License at http://www.apache.org/licenses/LICENSE-2.0

Unless required by applicable law or agreed to in writing, software distributed under
the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
OF ANY KIND, either express or implied. See the License for the specific language
governing permissions and limitations under the License.
*/

import { tag as html, TemplateResult } from '../custom-tag.js';

export { setCustomTemplateLiteralTag } from '../custom-tag.js';
export const ReplyAllIcon = ({
  width = 24,
  height = 24,
  hidden = false,
  title = 'Reply All',
} = {}): string | TemplateResult => {
  return html`<svg
    xmlns="http://www.w3.org/2000/svg"
    height="${height}"
    viewBox="0 0 36 36"
    width="${width}"
    aria-hidden=${hidden ? 'true' : 'false'}
    role="img"
    fill="currentColor"
    aria-label="${title}"
  >
    <path
      d="M22.105 6H22V3a.733.733 0 0 0-.739-.735.718.718 0 0 0-.513.216l-6.843 6.885a.735.735 0 0 0 0 .984l6.843 7.434a.718.718 0 0 0 .513.216.733.733 0 0 0 .739-.735V14a12.429 12.429 0 0 1 12.179 4.785.455.455 0 0 0 .821-.272C35 16.5 32.779 6 22.105 6ZM12.27 18.5H12v-3.765a.733.733 0 0 0-.739-.735.718.718 0 0 0-.513.216l-8.559 8.292a.735.735 0 0 0 0 .984l8.559 8.292a.718.718 0 0 0 .513.216.733.733 0 0 0 .739-.735v-3.548c6.4-1.033 12.118 2.748 15 6.379a.555.555 0 0 0 1-.332C28 31.313 25.29 18.5 12.27 18.5Z"
    />
  </svg>`;
};
